const LinkButton = ({ children, className = '', disabled, ...props }) => {
  return (
    <span {...props} className={`spo-a-link-button ${className} ${disabled ? 'disabled' : ''}`} role="button">
      {children}
    </span>
  );
};

export default LinkButton;
